export const getMenu = (menu: any) => {
  return (menu || []).map((item: any) => {
    const { PageData } = item;
    return {
      name: PageData?.Name,
      url: item.Link,
      pageTypeName: PageData?.PageTypeName,
      childItems: item.ChildItems
    }
  })
}

export const getSubMenu = (menu: any) => {
  return (menu || []).map((item: any) => {
    return {
      name: item?.Name,
      url: item?.Url,
      pageTypeName: item?.PageTypeName
    }
  })
}